/** @jsx createElement */
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { Template__TeamIdentifiesExploit } from '../../templates/team-identifies-exploit';

@observer
export class Slide11 extends Component {
  componentDidMount() {
    // Do something
  }

  render() {
    const { children } = this.props;
    return (
      <div className={`slide-11`}>
        {children}
        <Template__TeamIdentifiesExploit />
      </div>
    );
  }
}
